/* @flow */

import React from 'react';
import { get } from 'lodash';
import styled from '@emotion/styled';

type Props = {
  entities: Array<*>,
  label: string
};

const Wrapper = styled.div({});

const Title = styled.div(({ theme }) => ({
  fontSize: '0.9rem',
  fontWeight: theme.fontWeight.demiBold
}));

const PlayerList = styled.ul(({ theme }) => ({
  listStyle: 'none',
  fontSize: '0.83rem',
  fontWeight: theme.fontWeight.normal,
  margin: 0,
  padding: 0
}));

const PlayerItem = styled.li({});

const Bold = styled.span(({ theme }) => ({
  fontWeight: theme.fontWeight.bold
}));

function ChallengeEntryPosition({ entities, label }: Props) {
  return (
    <Wrapper>
      <Title>{label}</Title>
      <PlayerList>
        {entities.map(entity => (
          <PlayerItem key={entity.idStr}>
            {entity.name} <Bold>{get(entity, 'bonus.name') ? `(${entity.bonus.name})` : ''}</Bold>
          </PlayerItem>
        ))}
      </PlayerList>
    </Wrapper>
  );
}

export default ChallengeEntryPosition;
